import React from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton, Tooltip, Box } from '@mui/material';
import { FaFlagUsa, FaFlag } from 'react-icons/fa';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const handleLanguageChange = (lang) => {
    i18n.changeLanguage(lang);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 1,
      }}
    >
      <Tooltip title="English">
        <IconButton
          onClick={() => handleLanguageChange('en')}
          sx={{
            bgcolor: i18n.language === 'en' ? 'rgba(0,0,255,0.7)' : 'transparent',
            color: i18n.language === 'en' ? '#fff' : '#000',
            border: '1px solid',
            borderColor: i18n.language === 'en' ? 'transparent' : 'rgba(0,0,255,0.5)',
            '&:hover': {
              bgcolor: 'rgba(0,0,255,0.9)',
              color: '#fff',
              boxShadow: '0 0 10px rgba(0,0,255,0.5)',
              transform: 'scale(1.1)',
            },
            transition: 'all 0.2s ease-in-out',
            borderRadius: '50%',
            p: 0.5,
          }}
        >
          <FaFlagUsa size={18} />
        </IconButton>
      </Tooltip>
      <Tooltip title="فارسی">
        <IconButton
          onClick={() => handleLanguageChange('fa')}
          sx={{
            bgcolor: i18n.language === 'fa' ? 'rgba(0,128,0,0.7)' : 'transparent',
            color: i18n.language === 'fa' ? '#fff' : '#000',
            border: '1px solid',
            borderColor: i18n.language === 'fa' ? 'transparent' : 'rgba(0,128,0,0.5)',
            '&:hover': {
              bgcolor: 'rgba(0,128,0,0.9)',
              color: '#fff',
              boxShadow: '0 0 10px rgba(0,128,0,0.5)',
              transform: 'scale(1.1)',
            },
            transition: 'all 0.2s ease-in-out',
            borderRadius: '50%',
            p: 0.5,
          }}
        >
          <FaFlag size={18} />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default LanguageSwitcher;